var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.04973 14.835C7.2371 15.0213 7.49055 15.1258 7.75473 15.1258C8.01892 15.1258 8.27237 15.0213 8.45973 14.835L12.0497 11.295L15.5897 14.835C15.7771 15.0213 16.0305 15.1258 16.2947 15.1258C16.5589 15.1258 16.8124 15.0213 16.9997 14.835C17.0935 14.742 17.1679 14.6314 17.2186 14.5096C17.2694 14.3877 17.2955 14.257 17.2955 14.125C17.2955 13.993 17.2694 13.8623 17.2186 13.7404C17.1679 13.6186 17.0935 13.508 16.9997 13.415L12.7597 9.175C12.6668 9.08127 12.5562 9.00688 12.4343 8.95611C12.3125 8.90534 12.1817 8.8792 12.0497 8.8792C11.9177 8.8792 11.787 8.90534 11.6652 8.95611C11.5433 9.00688 11.4327 9.08127 11.3397 9.175L7.04973 13.415C6.95601 13.508 6.88161 13.6186 6.83084 13.7404C6.78007 13.8623 6.75393 13.993 6.75393 14.125C6.75393 14.257 6.78007 14.3877 6.83084 14.5096C6.88161 14.6314 6.95601 14.742 7.04973 14.835Z",
    fill: "#080808"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/chevron_up.55085d1c4325ccd2634eba51b248c33c.svg";
export { ForwardRef as ReactComponent };